import { TFunction } from 'i18next'
import { Config, UserInput } from 'shared/src/api/types'

import { FormValues as ProductFormValues } from '../ProductForm'
import {
  optionalUrlValidator,
  presentNumberValidator,
  presentStringValidator,
  presentUrlValidator,
  validUsernameValidator,
  validPhoneNumberValidator,
  Validator,
} from '../../utils/validators'

export const userValidator = (t: TFunction): Validator<UserInput> => ({
  username: validUsernameValidator(
    t('admin.resources.users.fields.username'),
    t
  ),
  phoneNumber: validPhoneNumberValidator(
    t('admin.resources.users.fields.phoneNumber'),
    t
  ),
  homepage: optionalUrlValidator(t('admin.resources.users.fields.homepage'), t),
  instagramUrl: optionalUrlValidator(
    t('admin.resources.users.fields.instagramUrl'),
    t
  ),
  pinterestUrl: optionalUrlValidator(
    t('admin.resources.users.fields.pinterestUrl'),
    t
  ),
  amazonUrl: optionalUrlValidator(
    t('admin.resources.users.fields.amazonUrl'),
    t
  ),
  tiktokUrl: optionalUrlValidator(
    t('admin.resources.users.fields.tiktokUrl'),
    t
  ),
  spotifyUrl: optionalUrlValidator(
    t('admin.resources.users.fields.spotifyUrl'),
    t
  ),
  goodreadsUrl: optionalUrlValidator(
    t('admin.resources.users.fields.goodreadsUrl'),
    t
  ),
  snapchatUrl: optionalUrlValidator(
    t('admin.resources.users.fields.snapchatUrl'),
    t
  ),
  youtubeUrl: optionalUrlValidator(
    t('admin.resources.users.fields.youtubeUrl'),
    t
  ),
  twitterUrl: optionalUrlValidator(
    t('admin.resources.users.fields.twitterUrl'),
    t
  ),
  etsyUrl: optionalUrlValidator(t('admin.resources.users.fields.etsyUrl'), t),
  facebookUrl: optionalUrlValidator(
    t('admin.resources.users.fields.facebookUrl'),
    t
  ),
  applePodcastsUrl: optionalUrlValidator(
    t('admin.resources.users.fields.applePodcastsUrl'),
    t
  ),
})

export const productUrlHasDomain = (url: string, domain: string): boolean =>
  url.includes(domain)

const allowedUrlValidator =
  (config: Config, t: TFunction) =>
  (value: string | null | undefined): string | null => {
    const presentUrlError = presentUrlValidator(
      t('admin.resources.products.fields.url'),
      t
    )(value)
    if (presentUrlError) return presentUrlError

    const forbiddenDomain = config.forbiddenProductUrlDomains.find((domain) =>
      productUrlHasDomain(value!, domain)
    )

    if (forbiddenDomain) {
      return t('admin.resources.general.errors.forbiddenUrlDomainError', {
        fieldName: t('admin.resources.products.fields.url'),
        domain: forbiddenDomain,
      })
    }

    return null
  }

export const productValidator = (
  config: Config,
  t: TFunction,
  userType: 'admin' | 'creator'
): Validator<ProductFormValues> => ({
  brandId: presentNumberValidator(
    t('admin.resources.products.fields.brand'),
    t
  ),
  name: presentStringValidator(t('admin.resources.products.fields.name'), t),
  url: userType === 'creator' ? allowedUrlValidator(config, t) : undefined,
  imageId: presentNumberValidator(
    t('admin.resources.products.fields.imageId'),
    t
  ),
})
